<script lang="ts">
	import { devices_settings } from 'src/stores/device-runtime/status';
	import { readDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	//Design system components
	import { Button, Container, Input, Stack, Text } from '@Shelly/shelly-design-system';
	//Helpers
	import { onSettingsResponse } from 'src/helpers/device_settings_helpers';
	//Services
	import { format } from 'svelte-i18n';
	import { gen2Request } from 'src/services/gen_2_http_reqs';
	//Stores
	//Types
	import type { SettingRequest } from 'src/types/requests/settings/setting';
	import { real_id } from 'src/helpers/interface_helpers';
	//Svelte hooks
	import { onMount } from 'svelte';

	export let device;

	let inputsSettings = {};
	let id = real_id(device.id),
		settings = readDeviceSettings(id),
		loading,
		cache;

	const getSettings = () => {
		Object.keys(settings).forEach((setting) => {
			if (setting.includes('input:') && Number(setting.split(':')[1]) < 100) {
				inputsSettings[setting.split(':')[1]] = settings[setting].name;
				loading = false;
			}
		});
		cache = Object.assign({}, inputsSettings);
	};
	const sentRequest = async () => {
		for (let inputChannel in inputsSettings) {
			if (cache[inputChannel] !== inputsSettings[inputChannel]) {
				loading = true;
				const res: SettingRequest = await gen2Request(device, 'Input.SetConfig', {
					id: inputChannel,
					config: { name: inputsSettings[inputChannel] },
				});

				const response = onSettingsResponse(res, device);
				if (response.isok) {
					settings[`input:${inputChannel}`].name = inputsSettings[inputChannel];
					devices_settings.update_devices_settings(id, settings);
					cache = Object.assign({}, inputsSettings);
				} else {
					inputsSettings = Object.assign({}, cache);
				}
			}
		}
		loading = false;
	};

	onMount(() => {
		getSettings();
	});
</script>

<Stack gap="s">
	{#each Object.keys(inputsSettings) as input, i}
		<Container padding="xs">
			<Text element="h2" styleType="h2" class="mb-s">
				{$format('text_set_name_device_input_id', {
					default: `Set name for device input ${i}:`,
					values: { index: i },
				})}
			</Text>
			<Input
				icon="fa-solid fa-microchip"
				type="text"
				bind:value={inputsSettings[input]}
				label={input}
				id="input-cf3xqml"
				aria-labelledby="input-cf3xqml"
			/>
		</Container>
	{/each}
	<Button class="mt-s" {loading} size="m" width="full" on:click={() => sentRequest()}>
		{$format('button_save')}
	</Button>
</Stack>
